import axios from "axios";

const API = "/api";
const THROTTLE_KEY = "push_reconcile_last";
const HEALTH_KEY = "push_health";
const THROTTLE_MS = 15 * 60 * 1000;

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

const setHealth = (v) => { try { localStorage.setItem(HEALTH_KEY, v); } catch (_) {} };
export const getPushHealth = () => { try { return localStorage.getItem(HEALTH_KEY) || ""; } catch (_) { return ""; } };

// iter69 F2 — self-healing reconciliation on EVERY app open / visibilitychange.
// Killer-agnostic: whatever disabled the subscription (logout, 410, reassign,
// revoke), if permission is still granted we silently re-subscribe/re-enable.
// Throttled 1x/15min. Emits [PUSH_RECONCILED reason=...] server-side when it repairs.
export async function reconcilePush(reason = "app_open", { force = false } = {}) {
  try {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) return;
    if (typeof Notification === "undefined") return;
    if (Notification.permission === "denied") { setHealth("denied"); return; }
    if (Notification.permission !== "granted") return; // never prompt silently

    if (!force) {
      const last = Number(localStorage.getItem(THROTTLE_KEY) || 0);
      if (Date.now() - last < THROTTLE_MS) return;
    }
    try { localStorage.setItem(THROTTLE_KEY, String(Date.now())); } catch (_) {}

    const reg = await navigator.serviceWorker.getRegistration();
    if (!reg) return;
    let sub = await reg.pushManager.getSubscription();
    let effectiveReason = reason;
    if (!sub) {
      effectiveReason = `${reason}:sub_missing`;
      const r = await axios.get(`${API}/push/vapid-public-key`);
      const key = r.data?.publicKey || r.data?.public_key;
      if (!key) return;
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(key),
      });
    } else {
      // backend truth check — row may be disabled or reassigned
      try {
        const st = await axios.post(`${API}/push/status`, { endpoint: sub.toJSON().endpoint });
        if (st.data?.enabled && st.data?.owned_by_me) effectiveReason = `${reason}:keepalive`;
        else effectiveReason = `${reason}:${!st.data?.exists ? "row_missing" : !st.data?.enabled ? "row_disabled" : "reassigned"}`;
      } catch (_) { /* still re-register below */ }
    }
    const j = sub.toJSON();
    await axios.post(`${API}/push/subscribe`, {
      endpoint: j.endpoint,
      keys: { p256dh: j.keys.p256dh, auth: j.keys.auth },
      user_agent: navigator.userAgent,
      platform: navigator.platform || "",
      context: "reconcile",
      reason: effectiveReason,
    });
    setHealth("ok");
  } catch (_e) {
    setHealth("broken");
  }
}
